export default {"src":"/_next/static/media/brokenGlass_40.6ede7197.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};